module.exports = "/_next/static/images/GetStartedBackground-83cf861f7ad744e82e9b245c93cddeca.png";